import React, { useState, useEffect } from "react";
import AceEditor from "react-ace";
import "ace-builds/webpack-resolver";
import "ace-builds/src-noconflict/mode-json";
import "ace-builds/src-noconflict/theme-dawn";
import "ace-builds/src-noconflict/mode-text";
import { isEmptyJsonObject } from "../../common/utils/helper";
import Page from "@atlaskit/page";
import { getFormatted } from "../../common/utils/formatter";
import Textfield from "@atlaskit/textfield";
import Tabs, { Tab, TabList, TabPanel } from "@atlaskit/tabs";
import JSONPath from "jsonpath";
import Spinner from "@atlaskit/spinner";
import { getAceEditorTheme } from "../../common/utils/aceEditorTheme";

const ScriptedLogDetails = ({ data }) => {
  const [filter, setFilter] = useState("");
  const [tab, setTab] = useState(0);
  const [body, setBody] = useState("");
  const [response, setResponse] = useState("");
  const [payload, setPayload] = useState("");
  const [scope, setScope] = useState("");
  const [verbose, setVerbose] = useState("");
  const [error, setError] = useState("");

  const getEditorValue = (input) => {
    const formatted = getFormatted(input);

    if (formatted === null || formatted === undefined) {
      return "";
    }

    return typeof formatted === "string" ? formatted : String(formatted);
  };

  const getEditorMode = (input) => {
    const formatted = getEditorValue(input);

    if (!formatted) {
      return "text";
    }

    try {
      JSON.parse(formatted);
      return "json";
    } catch (e) {
      return "text";
    }
  };

  useEffect(() => {
    if (data) {
      setBody(getEditorValue(getProperty("request")));
      setResponse(getEditorValue(data.response));
      setPayload(getEditorValue(data.payload));
      setScope(getEditorValue(data.scope));
      setVerbose(getEditorValue(data.verboseLog));
      setError(getEditorValue(data.errorText));
    }
  }, [data]);

  const filterByJsonPath = (input, path) => {
    try {
      if (!path) {
        return input;
      } else if (!input) {
        return "";
      }
      const obj = JSON.parse(input);
      const output = JSONPath.query(obj, path);
      return getEditorValue(output[0]);
    } catch (e) {
      return "";
    }
  };

  const getProperty = (property) => {
    if (!data) {
      return "";
    }

    if (!isEmptyJsonObject(data[property])) {
      return data[property];
    }
    return "";
  };
  const onFilterChange = (e) => {
    setFilter(e.target.value);

    const filteredBody = filterByJsonPath(
      getEditorValue(getProperty("request")),
      e.target.value
    );
    const filteredResponse = filterByJsonPath(
      getEditorValue(data.response),
      e.target.value
    );
    const filteredPayload = filterByJsonPath(
      getEditorValue(data.payload),
      e.target.value
    );
    const filteredScope = filterByJsonPath(
      getEditorValue(data.scope),
      e.target.value
    );
    setBody(filteredBody);
    setResponse(filteredResponse);
    setPayload(filteredPayload);
    setScope(filteredScope);
  };
  const changeTab = (t) => {
    setTab(t);
  };

  return (
    <Page>
      <Textfield
        name="filterBody"
        onChange={onFilterChange}
        value={filter}
        selected={tab}
        placeholder="Enter JSON Path to filter the data below"
      ></Textfield>
      {data?.scope?.key ? (
        <Spinner interactionName="load" label="Loading" />
      ) : (
        <Tabs onChange={changeTab} id="controlled">
          <TabList>
            <Tab>Script</Tab>
            <Tab>Result</Tab>
            <Tab>Scope</Tab>
          </TabList>
          <TabPanel>
            <div className="ihub-log-tab-warpper">
              <div className="ihub-log-tab">
                <p>The script executed on the server</p>
                <AceEditor
                  className="ihub-action-body-editor"
                  mode="javascript"
                  theme={getAceEditorTheme()}
                  name="body"
                  height="400px"
                  editorProps={{ $blockScrolling: true }}
                  value={getEditorValue(data?.script)}
                  showPrintMargin={false}
                />
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="ihub-log-tab-warpper">
              <div className="ihub-log-tab">
                <p>Result from executing the script</p>
                <AceEditor
                  className="ihub-action-body-editor"
                  mode={getEditorMode(data?.response)}
                  theme={getAceEditorTheme()}
                  name="response"
                  height="400px"
                  editorProps={{ $blockScrolling: true }}
                  value={response}
                />
              </div>
            </div>
          </TabPanel>
          <TabPanel>
            <div className="ihub-log-tab-warpper">
              <div className="ihub-log-tab">
                <p>
                  The full scope including payload and resolved variables from
                  the entire flow (including parent actions) available for this
                  action to operate on.{" "}
                </p>

                <AceEditor
                  className="ihub-action-body-editor"
                  mode={getEditorMode(data?.scope)}
                  theme={getAceEditorTheme()}
                  name="fullScope"
                  height="400px"
                  editorProps={{ $blockScrolling: true }}
                  value={scope}
                  showPrintMargin={false}
                />
              </div>
            </div>
          </TabPanel>
        </Tabs>
      )}
    </Page>
  );
};
export default ScriptedLogDetails;
